import React from "react";

const VideoCarouselComponent = (props) => {
    const { Renderer } = props;

    return <Renderer {...props} />;
};

export default VideoCarouselComponent;
